import React from 'react';
import { Link } from 'react-router-dom';
import HorizontalNormalDistribution from './HorizontalNormalDistribution.js';
import { useTheme } from '../context/ThemeContext.js';

const ArdenAcademy = () => {
  const { isLight } = useTheme();

  return (
    <section id="academy" className={`relative min-h-screen w-full border-t py-16 sm:py-24 overflow-hidden ${
      isLight ? 'border-gray-200' : 'border-white/5'
    }`}>
      <div className="max-w-[1600px] mx-auto px-4 sm:px-8 md:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center">

          {/* TEXT */}
          <div className="lg:col-span-5 flex flex-col gap-6 sm:gap-10 items-start">
            <div className="flex items-center gap-2 sm:gap-3">
              <div className={`w-1.5 h-1.5 rounded-full ${
                isLight ? 'bg-primary shadow-[0_0_8px_#5e19e6]' : 'bg-accent shadow-[0_0_8px_#00f0ff]'
              }`} />
              <span className={`text-[9px] sm:text-[10px] font-mono uppercase tracking-widest ${
                isLight ? 'text-primary' : 'text-accent'
              }`}>
                Education Platform
              </span>
            </div>

            {/* ACCENT + TEXT BLOCK */}
            <div className="relative pl-4 sm:pl-6">
              <div className={`absolute left-0 top-0 h-full w-[1px] bg-gradient-to-b to-transparent opacity-40 hidden md:block ${
                isLight ? 'from-primary/60' : 'from-accent/60'
              }`} />

              <h2 className={`text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light tracking-tight leading-[1.1] ${
                isLight ? 'text-gray-900' : 'text-white'
              }`}>
                Arden <br />
                <span className={`font-bold text-transparent bg-clip-text bg-gradient-to-r ${
                  isLight ? 'from-gray-900 via-gray-500 to-gray-300' : 'from-white via-white/70 to-white/20'
                }`}>
                  Academy.
                </span>
              </h2>

              <p className={`mt-4 sm:mt-6 text-base sm:text-lg font-light leading-relaxed max-w-[42ch] ${
                isLight ? 'text-gray-500' : 'text-white/60'
              }`}>
                Master the mathematics of markets through interactive simulations.
              </p>
            </div>

            {/* CTA Button */}
            <Link
              to="/academy"
              className={`group flex items-center gap-2 sm:gap-3 px-4 sm:px-6 py-2.5 sm:py-3 border rounded-lg text-xs sm:text-sm font-mono uppercase tracking-widest transition-all ${
                isLight
                  ? 'bg-primary/10 border-primary/30 text-primary hover:bg-primary hover:text-white'
                  : 'bg-accent/10 border-accent/30 text-accent hover:bg-accent hover:text-black'
              }`}
            >
              <span>Start Learning</span>
              <span className="material-symbols-outlined text-sm group-hover:translate-x-1 transition-transform">arrow_forward</span>
            </Link>
          </div>

          {/* GRAPH */}
          <div className="lg:col-span-7 flex items-center justify-center min-h-[250px] sm:min-h-[350px] md:min-h-[400px]">
            <HorizontalNormalDistribution />
          </div>

        </div>
      </div>
    </section>
  );
};

export default ArdenAcademy;
